import PropTypes from 'prop-types';
import React, { Component } from 'react';

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
export const WorkCoauthorsContainer = ({ freebieMention, children }) => (
  <div
    className="wp-workCard_item wp-workCard--coauthors"
    style={freebieMention ? { marginBottom: '0.5em' } : undefined}
  >
    <span>by </span>
    <span>
      <ul className="u-commaList">{children}</ul>
    </span>
  </div>
);

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'list' implicitly has an 'any' typ... Remove this comment to see the full error message
export const WorkCoauthors = ({ list, linkKey, textKey, freebieMention }) => {
  if (!list || !list.length) return null;
  return (
    <WorkCoauthorsContainer freebieMention={freebieMention}>
      {/* @ts-expect-error ts-migrate(7006) FIXME: Parameter 'item' implicitly has an 'any' type. */}
      {list.map((item, index) => (
        // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        <WorkCoauthor
          key={index}
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          linkKey={linkKey}
          textKey={textKey}
          item={item}
        />
      ))}
    </WorkCoauthorsContainer>
  );
};
WorkCoauthors.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  linkKey: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  textKey: PropTypes.string.isRequired,
  freebieMention: PropTypes.bool,
};

export class WorkCoauthor extends Component {
  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'item' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { item, linkKey, textKey } = this.props;
    return (
      <li>
        {linkKey && item[linkKey] ? (
          <a href={item[linkKey] || 'javascript:void(0);'} ref={this.userCard}>
            {item[textKey]}
          </a>
        ) : (
          <span>{item[textKey]}</span>
        )}
      </li>
    );
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
  userCard = (el) => {
    if (!el) return;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'item' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { item } = this.props;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'UserCard' does not exist on type 'typeof... Remove this comment to see the full error message
    new Aedu.UserCard({
      el: el,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'User' does not exist on type 'typeof Aed... Remove this comment to see the full error message
      user: Aedu.User.from_json(item),
    });
  };
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
WorkCoauthor.propTypes = {
  item: PropTypes.object.isRequired,
  linkKey: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  textKey: PropTypes.string.isRequired,
};
